import React, { useState } from 'react'
import { Modal, ModalBody } from 'reactstrap'

const LazyYouTubeModal = ({
  embedUrl,
  width = '100%',
  height = '360',
  title = 'YouTube video',
}) => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  // Extract video ID to show thumbnail
  const match = embedUrl.match(/\/embed\/([^?]+)/)
  const videoId = match ? match[1] : null
  const thumbnail = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null

  const styleWidth = typeof width === 'number' ? `${width}px` : width
  const styleHeight = typeof height === 'number' ? `${height}px` : height

  const autoplayUrl = open
    ? embedUrl + (embedUrl.includes('?') ? '&' : '?') + 'autoplay=1'
    : embedUrl

  const externalCloseBtn = (
    <button
      type="button"
      className="close videoclose"
      style={{ top: '10px', right: '10px', marginRight: '0' }}
      onClick={handleClose}
    >
      <svg className="crossico" width="20" height="20" viewBox="0 0 17 17">
        <path
          className="fill_path"
          d="M16.293 1.592l-1.3-1.3-6.7 6.701-6.7-6.7-1.3 1.299 6.7 6.7-6.7 6.701 1.3 1.3 6.7-6.7 6.7 6.7 1.3-1.3-6.7-6.7z"
        ></path>
      </svg>
    </button>
  )

  return (
    <>
      <div
        onClick={handleOpen}
        style={{
            width: styleWidth,
            height: styleHeight,
            backgroundImage: thumbnail ? `url(${thumbnail})` : undefined,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            cursor: 'pointer',
            position: 'relative',
            width: '640px',
            height: '360px',
            borderRadius: '22px',
            border: '5px solid rgb(255, 255, 255)',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '68px',
            height: '48px',
            backgroundColor: 'rgba(0,0,0,0.6)',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg viewBox="0 0 68 48" width="68" height="48">
            <path
              d="M66.52 7.05a8 8 0 0 0-5.6-5.65C56.17 0 34 0 34 0S11.83 0 7.08 1.4a8 8 0 0 0-5.6 5.65C0 12.85 0 24 0 24s0 11.15 1.48 16.95a8 8 0 0 0 5.6 5.65C11.83 48 34 48 34 48s22.17 0 26.92-1.4a8 8 0 0 0 5.6-5.65C68 35.15 68 24 68 24s0-11.15-1.48-16.95z"
              fill="red"
            />
            <path d="M45 24 27 14v20" fill="#fff" />
          </svg>
        </div>
      </div>
      <Modal isOpen={open} toggle={handleClose} external={externalCloseBtn} id="video-modal" style={{ borderRadius: '22px' }}>
        <ModalBody style={{ height: '100vh', overflow: 'hidden', borderRadius: '22px', padding: '20px' }}>
          {open && (
            <iframe
                style={{borderRadius: '22px',
                    border: '5px solid rgb(255, 255, 255)',
                }}
                width="100%"
                height="90%"
                src={autoplayUrl}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
          )}
        </ModalBody>
      </Modal>
    </>
  )
}

export default LazyYouTubeModal